export default "__VITE_ASSET__cu1196f1__"